import React, { Component } from 'react';

import { ConnectedRouter } from 'connected-react-router';
import { ThemeProvider } from '@material-ui/core/styles';
import { createBrowserHistory } from 'history';
import validate from 'validate.js';

// Css files for carrousel
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// TODO: remove hooks provider
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';


import { ToastContainer } from 'react-toastify';
import configureStore, { persistor } from './redux/Store';
import { AppStateProvider } from './components/AppProvider/AppProvider';

import Routes from './routes';
import 'react-toastify/dist/ReactToastify.css';

import validators from './utils/validators';
import theme from './theme';

import './assets/scss/index.scss';

export const browserHistory = createBrowserHistory();

validate.validators = {
  ...validate.validators,
  ...validators
};

class App extends Component {
  render() {
    console.log('version 0.0.1');
    return (
      <Provider store={configureStore}>

        <PersistGate loading={null} persistor={persistor}>
          <ToastContainer />
          <ThemeProvider theme={theme}>
            <AppStateProvider>
              <ConnectedRouter history={browserHistory}>
                <Routes />
              </ConnectedRouter>
            </AppStateProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
